import { maxRecommendedTextures } from '../../renderers/shared/texture/utils/maxRecommendedTextures';

export const MAX_TEXTURES = maxRecommendedTextures();
